import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input, InputNumber, Switch } from 'antd'
import type { Tables } from '@muaa/shared'

type Campaign = Tables<'campaigns'>

export function CampaignCreate() {
  const { formProps, saveButtonProps } = useForm<Campaign>()

  return (
    <Create saveButtonProps={saveButtonProps}>
      {/* `raised` and `donors` are server-managed (default 0, updated by the
          donations webhook), so they are not part of the create form. */}
      <Form {...formProps} layout="vertical" initialValues={{ is_active: true }}>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: 'Campaign title is required' }]}
        >
          <Input placeholder="e.g. Annual Fund 2025" />
        </Form.Item>

        <Form.Item
          label="Goal ($)"
          name="goal"
          rules={[{ required: true, message: 'Goal is required' }]}
        >
          <InputNumber
            min={0}
            precision={2}
            style={{ width: '100%' }}
            formatter={(value) =>
              value != null ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
            }
            parser={(value) => (value ? value.replace(/\$\s?|(,*)/g, '') : '') as any}
          />
        </Form.Item>

        <Form.Item label="Days Remaining" name="days_remaining">
          <InputNumber min={0} style={{ width: '100%' }} precision={0} />
        </Form.Item>

        <Form.Item label="Active" name="is_active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  )
}
